// SSR=UA, CSR=media query で OR 結合した「モバイル相当」判定。
// 判定の役割分担:
//   - UA: iPad/タブレットなど、画面幅は広いがタッチが主体のデバイス
//   - max-width: 狭幅のウィンドウ（リサイズも追従）
const MOBILE_MAX_WIDTH = '(max-width: 768px)'

export function useIsMobile() {
  const { isMobileOrTablet } = useDevice()
  const isNarrow = useMediaQuery(MOBILE_MAX_WIDTH)
  const isMobile = computed(() => isMobileOrTablet || isNarrow.value)
  return { isMobile }
}
